import React from "react";
import { UiComponents } from "@simulanisindia/ui";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";


const { GridView } = UiComponents;

const ResourceSkeleton = ({ length = 0 }) => {
    return (
        <>
            <GridView>
                {Array.from({ length: length }).map((_, index) => (
                    <div className="resource-card">
                        <div className="resource-thmub">
                            <Skeleton width="100%" height="7rem" />
                        </div>
                        <p className="resource-name">
                            <Skeleton width="90%" height="1rem" count={2} />
                        </p>
                    </div>
                ))}
            </GridView>
        </>
    )
}

export default ResourceSkeleton
